/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsherocaption2Inputs */

const en_statsherocaption2 = /** @type {(inputs: Statsherocaption2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The last 7 days. Pick a figure to see how it developed.`)
};

const de_statsherocaption2 = /** @type {(inputs: Statsherocaption2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die letzten 7 Tage. Wähle eine Kennzahl, um ihren Verlauf zu sehen.`)
};

/**
* | output |
* | --- |
* | "The last 7 days. Pick a figure to see how it developed." |
*
* @param {Statsherocaption2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsherocaption2 = /** @type {((inputs?: Statsherocaption2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsherocaption2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsherocaption2(inputs)
	return de_statsherocaption2(inputs)
});
export { statsherocaption2 as "statsHeroCaption" }